// extracted by mini-css-extract-plugin
export default {"wrapper":"payroll_wrapper__fdCxJ","header":"payroll_header__YfUuu"};